export default "__VITE_ASSET__BNo0UDy1__"